package com.essntl.features.service.ui.allservice.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.features.profile.domain.model.ProfileModel
import com.essntl.features.service.ui.allservice.AllServiceState
import com.essntl.uikit.components.button.primary.EsLargePrimaryButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.icons.EsLargeIcon
import com.essntl.uikit.components.input.EsInput
import com.essntl.uikit.components.utils.EsConstants
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun AllServiceHeader(
    state: AllServiceState,
    isSidePanelOpen: Boolean,
    onAddService: () -> Unit,
    searchText: String,
    onSearchTextChange: (String) -> Unit,
    modifier: Modifier = Modifier,
) {
    val currentUserRole = remember(state.getCurrentProfile.data) {
        state.getCurrentProfile.data?.role
    }

    Row(
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween,
        modifier = modifier
            .fillMaxWidth()
            .clip(RoundedCornerShape(EsConstants.SectionBorderRadius))
            .background(MaterialTheme.esColorScheme.bgSecondary)
            .padding(
                vertical = EsConstants.SectionVerticalPadding,
                horizontal = EsConstants.SectionHorizontalPadding,
            ),
    ) {
        Text(
            text = "Services",
            color = MaterialTheme.esColorScheme.textPrimary,
            style = MaterialTheme.esTypography.h2Bold32,
        )

        EsInput(
            value = searchText,
            onValueChange = {
                onSearchTextChange(it)
            },
            placeholder = "Search",
            prefix = {
                EsLargeIcon(
                    res = EsIcons.Search,
                )
            },
            singleLine = true,
            modifier = Modifier
                .width(300.dp),
        )

        if ((currentUserRole == ProfileModel.Role.Admin ||
                currentUserRole == ProfileModel.Role.Supervisor ||
                currentUserRole == ProfileModel.Role.Owner) && !isSidePanelOpen
        ) {
            EsLargePrimaryButton(
                onClick = onAddService,
                text = "New service",
                suffixIconRes = EsIcons.Add,
            )
        }
    }
}
